import { Link, useLocation } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import ScrollToTop from './ScrollToTop';
import UserMenu from './auth/UserMenu';

export default function AppContent() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <>
      <ScrollToTop />

      <nav className="bg-black text-white px-6 py-4 flex justify-between items-center sticky top-0 z-50 shadow-md">
        <a href="/">
          <img
            src="/kernelDark.png"
            alt="Kernel Dark Logo"
            className="h-8 w-auto"
          />
        </a>
        <ul className="flex gap-6 text-sm items-center">
          <li>
            <a
              href={isHomePage ? '#hero' : '/#hero'}
              className="hover:text-blue-400"
            >
              Home
            </a>
          </li>
          <li>
            <a
              href={isHomePage ? '#solutions' : '/#solutions'}
              className="hover:text-blue-400"
            >
              Solutions
            </a>
          </li>
          <li>
            <a
              href={isHomePage ? '#differentiators' : '/#differentiators'}
              className="hover:text-blue-400"
            >
              Differentiators
            </a>
          </li>
          <li>
            <a
              href={isHomePage ? '#products' : '/#products'}
              className="hover:text-blue-400"
            >
              Products
            </a>
          </li>
          <li>
            <Link to="/trial" className="hover:text-blue-400">
              Trial
            </Link>
          </li>
          <li>
            <Link to="/rebate-model" className="hover:text-blue-400">
              Rebate Model
            </Link>
          </li>
          <li>
            <Link to="/map" className="hover:text-blue-400">
              Medicaid Map
            </Link>
          </li>
          {/* <li>
            <Link to="/dispute" className="hover:text-blue-400">
              Dispute
            </Link>
          </li> */}
          <li>
            <Link to="/about" className="hover:text-blue-400">
              About
            </Link>
          </li>
          <li>
            <Link to="/articles" className="hover:text-blue-400">
              Articles
            </Link>
          </li>
          <li>
            <Link to="/contact" className="hover:text-blue-400">
              Contact Us
            </Link>
          </li>
          <li>
            <UserMenu />
          </li>
        </ul>
      </nav>

      {/* Mount the actual route views */}
      <AppRoutes />

      <footer className="bg-black text-gray-500 py-8 border-t border-gray-700">
        <div className="max-w-4xl mx-auto px-4 flex flex-col items-center justify-center gap-4">
          {/* Images + Text Row */}
          <div className="flex items-center justify-center gap-4">
            <img src="/soc1.png" alt="SOC1" className="h-[48px]" />

            <p className="text-sm text-center">
              &copy; {new Date().getFullYear()} Kernel Solutions Inc. All rights
              reserved. &nbsp;
              <a href="/terms" className="text-blue-400 hover:underline">
                Terms of Service
              </a>{' '}
              &nbsp;|&nbsp;
              <a href="/privacy" className="text-blue-400 hover:underline">
                Privacy Policy
              </a>{' '}
              &nbsp;|&nbsp;
              <a href="/security" className="text-blue-400 hover:underline">
                Security
              </a>
            </p>

            <img src="/soc2.png" alt="SOC2" className="h-[48px]" />
          </div>
        </div>
      </footer>
    </>
  );
}
